<template>
    <!-- 外层容器：设置全局背景色 -->
    <div class="protocol-page-wrapper">
        <!-- 主体容器：保持原有宽度 -->
        <div class="protocol-container">
            <!-- <el-button type="text" @click="goLogin" style="float: left;color: #999;" icon="el-icon-arrow-left">
                返回登录页
            </el-button> -->
            <div class="protocol-header">
                <h1>通用格式购前帮助文档</h1>
            </div>
            <div class="protocol-content">
                <!-- 这里放置服务协议的具体内容 -->
                <div class="protocol-section">
                    <p>FBX和OBJ文件，仅作为原始文件格式的额外赠送服务，极端情况下在不同软件中会有不兼容的情况导致无法使用，可在购买前联系客服打开查看，由于文件在不同软件不兼容造成的售后问题，平台仅作为中间方协助买家和卖家做退款协商调解，不能保证做退款处理。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>1、动画：</h2>
                    <p>FBX文件仅支持蒙皮动画和点缓存动画，但不能保证再任何三维软件中都能兼容运行，如需要用到动画，请在购买前联系我们的客服打开查看，购买后不兼容问题不支持退款。OBJ模型没有动画。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>2、模型：</h2>
                    <p>FBX和OBJ包含所有的多边形网格模型，但不能存储历史记录和修改器信息，在不同的软件中可能存在破面、乱面、布线轻微改变等问题（此情况常见于C4D等非Autodesk公司的软件产品导出的FBX），在少数软件中打开可能显示为三角面。可在购买前联系我们的客服打开查看，购买后不兼容问题造成的乱面和破面不支持售后退款。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>3、骨骼：</h2>
                    <p>FBX支持骨骼（Skeleton）、蒙皮网格（Skeletal Mesh）和动作序列（Animation
                        Sequence），但不保证在任何三维软件中都能兼容运行，如需用到骨骼，请在购买前联系我们的客服打开查看，购买后不兼容问题不支持退款。OBJ模型没有骨骼。</p>
                </div>
                <div class="protocol-section">
                    <h2>4、变形和蒙皮：</h2>
                    <p>FBX可以导出蒙皮和变形，但不保证在任何三维软件中都能兼容运行，如需用到蒙皮和变形，请在购买前联系我们的客服打开查看，购买后不兼容问题不支持退款。OBJ模型没蒙皮和变形。</p>
                </div>
                <div class="protocol-section">
                    <h2>5、点缓存动画：</h2>
                    <p>FBX可以导出点缓存动画，但不保证在任何三维软件中都能兼容运行，如需用到点缓存动画，可在购买前联系我们的客服打开查看，购买后不兼容问题不支持退款。OBJ模型没有点缓存动画。</p>
                </div>
                <div class="protocol-section">
                    <h2>6、UV：</h2>
                    <p>如果原始文件模型UV展开了，FBX和OBJ文件也可以保存UV信息，但OBJ仅能保存一套UV，原始模型UV未展开UV，则FBX也没有UV信息。</p>
                </div>
                <div class="protocol-section">
                    <h2>7、材质：</h2>
                    <p>FBX和OBJ不能完美还原原始文件的材质效果，需要在导入其他软件后自行调整矫正，可在购买前联系客服核实，购买后在第三方软件的材质未达到预期效果不支持售后。</p>
                </div>
                <div class="protocol-section">
                    <h2>8、贴图：</h2>
                    <p>原始文件格式中若使用了第三方渲染器，则导出的FBX和OBJ文件没有贴图信息，如果原始模型有展开UV，并且使用默认渲染器和材质球，那么FBX文件有贴图信息，但一般只包含漫反射（如果原始文件有的话），其他贴图仍需导入软件后重新指定。可在购买前联系客服打开核实，购买后在第三方软件贴图路径丢失造成的未达到预期效果不支持售后。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>9、灯光和HDR：</h2>
                    <p>FBX和OBJ均无法完美存储原模型的灯光信息，均需在导入软件后重新打光，购买后导入任何三维软件由于灯光和HDR造成的未达到预期效果不支持售后。</p>
                </div>
                <div class="protocol-section">
                    <h2>10、单位比例：</h2>
                    <p>FBX和OBJ的单位比例可能和您要导入的场景不是同一单位，可能造成导入模型后模型过大或过小，需要手动缩放模型。但如果模型带有绑定和蒙皮。缩放可能造成模型无法使用，可在购买前联系客服确认模型单位尺寸。带绑定的模型购买后由于缩放造成的问题不支持售后。
                    </p>
                </div>
                <div class="protocol-section">
                    <h2>11、VR代理文件：</h2>
                    <p>如原始文件中包含代理文件，则仅能在原始文件中使用描述的渲染器渲染，FBX和OBJ文件无法导出FBX文件，代理文件也无法导入引擎类软件。</p>
                </div>
                <!-- 更多协议内容... -->
            </div>
        </div>
        <!-- 底部版权：固定在页面底部 -->
        <div class="protocol-footer-wrapper">
            <!-- <Bottom></Bottom> -->
        </div>
    </div>
</template>

<script>
import Bottom from '../../components/Footer.vue';
export default {
    name: 'PrivacyPolicy',
    components: {
        Bottom
    },
    methods: {
        goLogin() {
            this.$router.push('/Login');
        },
    }
}
</script>

<style lang="less" scoped>
// 页面外层容器：设置全局背景色，确保占满整个视口
.protocol-page-wrapper {
    width: 100%;
    min-height: 100vh;
    background-color: #232323; // 两侧背景色
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

// 主体容器：保持原有宽度，内容居中
.protocol-container {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;
    box-sizing: border-box; // 确保padding不影响宽度
    flex: 1; // 占满除底部外的剩余空间
}

.protocol-header {
    text-align: center;
    margin-bottom: 30px;
    padding-bottom: 20px;
    border-bottom: 1px solid #444; // 适配深色背景的分隔线

    h1 {
        font-size: 24px;
        color: #E3E3E3;
        font-weight: 600;
    }
}

.protocol-content {
    font-size: 16px;
    line-height: 1.8;
    color: #ACACAC;

    .protocol-section {
        margin-bottom: 25px;

        h2 {
            font-size: 18px;
            color: gainsboro;
            margin-bottom: 10px;
            font-weight: bold;
        }

        p {
            margin-bottom: 10px;
            text-indent: 2em;
        }
    }
}
</style>